import { useEffect, useRef, useState } from "react";
import { Check } from "lucide-react";

export default function AreaSavedChip() {
  const [show, setShow] = useState(false);
  const timer = useRef(null);
  useEffect(() => {
    const h = () => {
      setShow(true);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setShow(false), 1600);
    };
    window.addEventListener("sgex:area-saved", h);
    return () => { window.removeEventListener("sgex:area-saved", h); if (timer.current) clearTimeout(timer.current); };
  }, []);
  if (!show) return null;
  return (
    <div data-testid="area-saved-chip"
      className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[2000] flex items-center gap-1.5 px-3 h-8 rounded-full bg-emerald-600 text-white text-xs font-medium shadow-lg animate-fade-in">
      <Check size={14} /> All changes saved
    </div>
  );
}
